import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemParams } from '../models/iCourrier/params-admin/system-params';
import { NaturesSources } from '../models/iCourrier/params-admin/natures-sources';
import { DocumentTemplateDTO } from '../interfaces/documents/document-template-dto.interface';
import { environment } from 'src/environments/environment';
import { ValidationCSSignatureDTO } from '../models/iCourrier/document-template';

@Injectable({
  providedIn: 'root',
})
export class ParamsService {
  public apiICourrierBaseUrl = '';
  public body: FormData = new FormData();
  public headers;

  public params: HttpParams = new HttpParams();

  constructor(public http: HttpClient) {
    const config = environment;
    this.apiICourrierBaseUrl = config.apiICourrierBaseUrl;
  }

  // #region System Params
  getParamsSystem(): Observable<SystemParams[]> {
    return this.http.get<SystemParams[]>(`${this.apiICourrierBaseUrl}/Management/SystemParameters`);
  }
  //#endregion

  // #region Natures Sources
  postNaturesSources(data: Omit<NaturesSources, 'id' | 'naturePrivee'>): Observable<NaturesSources> {
    return this.http.post<NaturesSources>(`${this.apiICourrierBaseUrl}/Management/NaturesSources`, data);
  }
  //#endregion

  // #region ProcedureValidations Signature Step Management
  getProcedureValidationsSignatures(id: number): Observable<ValidationCSSignatureDTO[]> {
    return this.http.get<ValidationCSSignatureDTO[]>(`${this.apiICourrierBaseUrl}/Management/ProcedureValidations/${id}/Signatures`);
  }
  //#endregion

  // #region Document model Management
  getModeleById(id: number): Observable<DocumentTemplateDTO> {
    return this.http.get<DocumentTemplateDTO>(`${this.apiICourrierBaseUrl}/Global/Documents/Templates/${id}`);
  }
  //#endregion

  // #region Avatar management
  getAvatar(): Observable<Blob> {
    return this.http.get<Blob>(`${this.apiICourrierBaseUrl}/Me/Avatar`, { responseType: 'blob' as 'json' });
  }

  putAvatar(file: Blob): Observable<HttpEvent<void>> {
    this.headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
    });
    const body = new FormData();
    body.append('Avatar', file);
    return this.http.put<void>(`${this.apiICourrierBaseUrl}/Me/Avatar`, body, this.headers);
  }
  //#endregion
}
